'use strict';

var _regeneratorRuntime = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _objectSpread = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _classCallCheck = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\chris\\Documents\\Code\\PerspectiveDeveloper\\CattlepassDapp\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var Client = require('../../lib/core');

var toUrlSearchParams = require('../../lib/to-url-search-params');
/**
 * @typedef {import('../../types').Options} Options
 * @typedef {import('ipfs-core-types/src/utils').AbortOptions} AbortOptions
 * @typedef {import('ipfs-core-types/src/pin/remote/service').Credentials} Credentials
 * @typedef {import('ipfs-core-types/src/pin/remote/service').RemotePinService} RemotePinService
 * @typedef {import('ipfs-core-types/src/pin/remote/service').RemotePinServiceWithStat} RemotePinServiceWithStat
 * @typedef {import('../../types').HTTPClientExtraOptions} HTTPClientExtraOptions
 * @typedef {import('ipfs-core-types/src/pin/remote/service').API<HTTPClientExtraOptions>} RemotePiningServiceAPI
 */


var Service = /*#__PURE__*/function () {
  /**
   * @param {Options} options
   */
  function Service(options) {
    _classCallCheck(this, Service);

    this.client = new Client(options);
  }
  /**
   * @param {URL} url
   */


  _createClass(Service, null, [{
    key: "encodeEndpoint",
    value: function encodeEndpoint(url) {
      var href = String(url);

      if (href === 'undefined') {
        throw Error('endpoint is required');
      } // Workaround trailing `/` issue in go-ipfs
      // @see https://github.com/ipfs/go-ipfs/issues/7826


      return href[href.length - 1] === '/' ? href.slice(0, -1) : href;
    }
    /**
     * @param {any} json
     * @returns {RemotePinServiceWithStat}
     */

  }, {
    key: "decodeRemoteService",
    value: function decodeRemoteService(json) {
      return _objectSpread({
        service: json.Service,
        endpoint: new URL(json.ApiEndpoint)
      }, json.Stat && {
        stat: Service.decodeStat(json.Stat)
      });
    }
    /**
     * @param {any} json
     * @returns {import('ipfs-core-types/src/pin/remote/service').Stat}
     */

  }, {
    key: "decodeStat",
    value: function decodeStat(json) {
      switch (json.Status) {
        case 'valid':
          {
            var _json$PinCount = json.PinCount,
                Pinning = _json$PinCount.Pinning,
                Pinned = _json$PinCount.Pinned,
                Queued = _json$PinCount.Queued,
                Failed = _json$PinCount.Failed;
            return {
              status: 'valid',
              pinCount: {
                queued: Queued,
                pinning: Pinning,
                pinned: Pinned,
                failed: Failed
              }
            };
          }

        case 'invalid':
          {
            return {
              status: 'invalid'
            };
          }

        default:
          {
            return {
              status: json.Status
            };
          }
      }
    }
  }]);

  return Service;
}();
/**
 * @type {RemotePiningServiceAPI["add"]}
 */


Service.prototype.add = /*#__PURE__*/function () {
  var _add = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(name, options) {
    var endpoint, key, headers, timeout, signal;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            endpoint = options.endpoint, key = options.key, headers = options.headers, timeout = options.timeout, signal = options.signal;
            _context.next = 3;
            return this.client.post('pin/remote/service/add', {
              timeout: timeout,
              signal: signal,
              searchParams: toUrlSearchParams({
                arg: [name, Service.encodeEndpoint(endpoint), key]
              }),
              headers: headers
            });

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function add(_x, _x2) {
    return _add.apply(this, arguments);
  }

  return add;
}();
/**
 * @type {RemotePiningServiceAPI["rm"]}
 */


Service.prototype.rm = /*#__PURE__*/function () {
  var _rm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name) {
    var options,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            options = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
            _context2.next = 3;
            return this.client.post('pin/remote/service/rm', {
              timeout: options.timeout,
              signal: options.signal,
              headers: options.headers,
              searchParams: toUrlSearchParams({
                arg: name
              })
            });

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  function rm(_x3) {
    return _rm.apply(this, arguments);
  }

  return rm;
}();
/**
 * @type {RemotePiningServiceAPI["ls"]}
 */


Service.prototype.ls = /*#__PURE__*/function () {
  var _ls = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var options,
        stat,
        headers,
        timeout,
        signal,
        response,
        _yield$response$json,
        RemoteServices,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
            // @ts-ignore cannot derive option type from typedef
            stat = options.stat, headers = options.headers, timeout = options.timeout, signal = options.signal;
            _context3.next = 4;
            return this.client.post('pin/remote/service/ls', {
              timeout: timeout,
              signal: signal,
              headers: headers,
              searchParams: stat === true ? toUrlSearchParams({
                stat: stat
              }) : undefined
            });

          case 4:
            response = _context3.sent;
            _context3.next = 7;
            return response.json();

          case 7:
            _yield$response$json = _context3.sent;
            RemoteServices = _yield$response$json.RemoteServices;
            return _context3.abrupt("return", RemoteServices.map(Service.decodeRemoteService));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  function ls() {
    return _ls.apply(this, arguments);
  }

  return ls;
}();

module.exports = Service;